import { render, staticRenderFns } from "./CarBack.vue?vue&type=template&id=3550d779&scoped=true&"
import script from "./CarBack.vue?vue&type=script&lang=ts&"
export * from "./CarBack.vue?vue&type=script&lang=ts&"
import style0 from "./CarBack.vue?vue&type=style&index=0&id=3550d779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550d779",
  null
  
)

export default component.exports